var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroesseViereck02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse-Viereck-02__Icn/40px/Groesse-Viereck-02",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse-Viereck-02__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Groesse-Viereck-02__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31,12 L31,28 L9,28 L9,12 L31,12 Z M29,14 L11,14 L11,26 L29,26 L29,14 Z",
    id: ".._.._src_svg_Icn_40px_Groesse-Viereck-02__Rectangle-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroesseViereck02);
export default __webpack_public_path__ + "static/media/Groesse-Viereck-02.ba5b838b14c4787347d255ae6623bcc7.svg";
export { ForwardRef as ReactComponent };